<template>
    <span class="card" @click="downloadFile"></span>
  </template>
  
  <script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator'
  
  @Component({})
  export default class HomeDownloadPdf extends Vue {
    @Prop({ type: String, required: true }) readonly fileSrc!: string    
    @Prop({ type: String, default: 'downloaded-file.pdf' }) readonly downloadName!: string
  
    async downloadFile(): Promise<void> {
      try {
        const response = await fetch(this.fileSrc)        
        const blob = await response.blob()        
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.downloadName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Erro ao baixar o arquivo:', error)
      }
    }
  }
  </script>